module.exports = __webpack_public_path__ + "images/skewness-07-faq-desktop.png";